import {Component, Injector, Input, OnInit, ViewEncapsulation} from '@angular/core';
import { AdsBannersService } from 'projects/common/services/ads-banners.service';
import {AdType} from "../ads-banners/ads-banners.component";
import { Module } from 'projects/common/model/ModuleModel';
import { AbstractComponent } from '../abstract.component';

@Component({
  selector: 'ads-regular-banners',
  template: `

    <div class="eva-3-row regular-ads center desktop">
      <div class="col -sm-12 mobile-spacing" [ngClass]="ad1 === 'regular1' ? '-md-7' : '-md-6'">
        <ads-banners [bannerType]="ad1" [moduleId]="MODULE_ID"></ads-banners>
      </div>
      <div class="col -sm-12" [ngClass]="ad2 === 'regular2' ? '-md-5' : '-md-6'">
        <ads-banners [bannerType]="ad2" [moduleId]="MODULE_ID"></ads-banners>
      </div>
    </div>

  `,
  styleUrls: ['./ads-regular-banners.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AdsRegularBannersComponent extends AbstractComponent implements OnInit {
  public MODULE_ID: string = "AdsRegularBannersModule";
  @Input() override module: Module<any>;
  ad1: AdType;
  ad2: AdType;

  constructor(injector: Injector, private adsRegularBanners: AdsBannersService) {
    super(injector);
  }

  ngOnInit(): void {

    const regularType: AdType[] = this.adsRegularBanners.resolveRegularType()
    this.ad1 = regularType[0];
    this.ad2 = regularType[1];
  }

  getModuleId(): string {
    return this.MODULE_ID;
  }
}
